export default __webpack_public_path__ + "0659a9f4e90db5cf51b50d005bff1e41.woff";